import Svg, { Path } from 'react-native-svg'

export const SearchIcon = ({ color = '#141414', width = 16, height = 16 }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M6.67 1.334a4.667 4.667 0 0 1 3.733 7.46l4.073 4.067a.665.665 0 0 1 0 .946.668.668 0 0 1-.947 0L9.463 9.734a4.667 4.667 0 1 1-2.794-8.4Zm0 8a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Z"
      />
    </Svg>
  )
}
